// extracted by mini-css-extract-plugin
export default {"gamePageWrapperRobo":"GameWrapper_gamePageWrapperRobo__BGeIb","gamePageWrapperMusic":"GameWrapper_gamePageWrapperMusic__zCjis GameWrapper_gamePageWrapperRobo__BGeIb"};